export const AMPLITUDE_API_KEY = 'ec07fdad5bcb992e602a25170b2d69bf'
export const COUNTRY = 'tg'
